import { mountBrightcovePosterPlayer } from './shared-brightcove-embed';

export function mount(root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>('[data-brightcove-player]').forEach(player => {
    mountBrightcovePosterPlayer(player, {
      frameClassName: player.dataset.frameClass || 'generic-card__video-frame',
      playButtonSelector: '[data-brightcove-play]'
    });
  });
}
